import { CloseOutlined } from '@ant-design/icons';
import React from 'react';
import { SignUpForm } from '../../../../modules/LoginRouter/components/SignUpForm/SignUpForm';
import metaLogoSrc from 'assets/meta-partner.png';
import styles from './SignupXray.module.css';
import { LeaderBadge } from '../../../../modules/LoginRouter/components/LoginLayout/components/Badges/LeaderBadge';
import { useResolutionInfo } from '@mm/hooks';
import { MOBILE_SMALL } from '../../../../editor/constants/screenSize';
import { trackWebAppGAEvent } from '../../../../common/helpers/plugins/website-google-analytics';

export const SignupXray = ({
  onClose,
  website,
}: {
  onClose: () => void;
  website: string;
}) => {
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_SMALL;
  const version = localStorage.getItem('onboardingReportVersion');
  const onSubmitSuccess = () => {
    trackWebAppGAEvent('click', {
      category: 'login',
      label: `x-ray-onboarding-signup-success-${version}`,
    });
    onClose();
  };
  return (
    <div className={styles.container}>
      <CloseOutlined className={styles.closeIcon} onClick={onClose} />
      {!isMobile && (
        <>
          <LeaderBadge className={styles.leader} whiteStyle />
          <img src={metaLogoSrc} className={styles.meta} />
        </>
      )}
      <SignUpForm
        requiredOnlyFields
        hideTrial
        showFacebook={false}
        withPasswordConfirmation={false}
        onSubmitSuccess={onSubmitSuccess}
        forXrayOnboarding
        withPhone
        websiteURL={website}
        heading="Where do you want to send your Lead List?"
        signUpButtonName="Sign Up"
        css={{
          form: styles.form,
          heading: styles.heading,
          submitBtn: styles.submitBtn,
          helpText: styles.helpText,
        }}
      />
    </div>
  );
};
